module.exports = __webpack_public_path__ + "static/img/call5.b0e636e6.jpg";